import script from "./MyEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./MyEvents.vue?vue&type=script&setup=true&lang=js"

import "./MyEvents.vue?vue&type=style&index=0&id=73a36579&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73a36579"]])

export default __exports__